module.exports = __webpack_public_path__ + "img/31b)(Kempinski Hotel Heiligendamm )Möbilierung von über 300 Zimmer.jpg";